(function() {
    'use strict';

    angular.module('competence')
        .controller('CompetenceListController', CompetenceListController);

    CompetenceListController.$inject = ['$scope', '$state', '$window', 'notificationSrvc', 'lodashService', 'competenceDataSrvc', 'competenceSrvc', 'competenceMessagesConst', 'datatableDefaultPageSizeValueConst', 'searchFilterSrvc', 'checkSearchSrvc', 'competencePermissionsConst', 'filterQuerySrvc'];

    function CompetenceListController($scope, $state, $window, notificationSrvc, lodashService, competenceDataSrvc, competenceSrvc, competenceMessagesConst, datatableDefaultPageSizeValueConst, searchFilterSrvc, checkSearchSrvc, competencePermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: 0,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.groupsRows = [];
        self.groupsCols = [{
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Sklep',
            value: 'country_display',
            type: 'text',
            orderValue: 'country',
            searchable: true,
            orderable: true
        }, {
            title: 'Reklamacja',
            value: 'reclamation',
            type: 'boolean',
            searchable: true,
            orderable: true
        }, {
            title: 'Powód reklamacji',
            value: 'complaint_reason',
            type: 'boolean',
            searchable: true,
            orderable: true
        }, {
            title: 'Negocjacja',
            value: 'negotiations',
            type: 'boolean',
            searchable: true,
            orderable: true
        }];

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.modelPermissions = competencePermissionsConst;
        self.searchQuery = {
            name: null,
            country_display: null,
            reclamation: null,
            complaint_reason: null,
            negotiations: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;
        self.onReorder = onReorder;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getCompetences();
        }

        function getCompetences(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    name: self.searchQuery.name,
                    country_display: self.searchQuery.country_display,
                    reclamation: searchFilterSrvc.getCheckboxFilterValue(self.searchQuery.reclamation),
                    complaint_reason: searchFilterSrvc.getCheckboxFilterValue(self.searchQuery.complaint_reason),
                    negotiations: searchFilterSrvc.getCheckboxFilterValue(self.searchQuery.negotiations),
                    ordering: self.searchQuery.ordering
                };
            }
            return competenceDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.groupsRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getCompetences);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.competence.create');
        }

        function onEdit(row) {
            $state.go('layout.competence.update', { pk: row.pk });
        }

        function onDelete(row) {
            return competenceSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", competenceMessagesConst.delete);
                lodashService.remove(self.groupsRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getCompetences();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getCompetences();
        }

        function onReorder(row, newPos) {
            return competenceDataSrvc.update({
                pk: row.pk
            }, {
                position: newPos
            });
        }
    }
})();
